import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$alias/_app/quality/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_authenticated/$alias/_app/quality/"!</div>
}
